/* global axios */

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

const state = {
  whitelist: [],
  quarantine: [],
  config: null,
  loading: false,
  error: null,
}

const getters = {
  whitelist: (state) => state.whitelist,
  quarantine: (state) => state.quarantine,
  config: (state) => state.config,
  loading: (state) => state.loading,
  error: (state) => state.error,
}

const mutations = {
  SET_LOADING(state, payload) { state.loading = payload; },
  SET_ERROR(state, payload) { state.error = payload; },
  SET_WHITELIST(state, payload) { state.whitelist = payload; },
  SET_QUARANTINE(state, payload) { state.quarantine = payload; },
  SET_CONFIG(state, payload) { state.config = payload; },
}

const actions = {
  async getWhitelist({ commit }, { accountId, inboxId, page = 1, pageSize = 10 }) {
    commit('SET_LOADING', true);
    try {
      const res = await axios.get(
        knowledgeProxy(accountId, `/whitelist/accounts/${accountId}/inboxes/${inboxId}?page=${page}&page_size=${pageSize}`)
      );
      commit('SET_WHITELIST', res.data);
    } catch (err) {
      commit('SET_ERROR', err);
      throw err;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async addWhitelistQuestion({ commit }, { accountId, inboxId, question }) {
    commit('SET_LOADING', true);
    try {
      await axios.post(
        knowledgeProxy(accountId, `/whitelist/accounts/${accountId}/inboxes/${inboxId}`),
        { question }
      );
    } catch (err) {
      commit('SET_ERROR', err);
      throw err;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteWhitelistQuestion({ commit }, { accountId, inboxId, questionId }) {
    commit('SET_LOADING', true);
    try {
      await axios.delete(
        knowledgeProxy(accountId, `/whitelist/accounts/${accountId}/inboxes/${inboxId}/questions/${questionId}`)
      );
    } catch (err) {
      commit('SET_ERROR', err);
      throw err;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async getQuarantine({ commit }, { accountId, inboxId, page = 1, pageSize = 10 }) {
    commit('SET_LOADING', true);
    try {
      const res = await axios.get(
        knowledgeProxy(accountId, `/whitelist/accounts/${accountId}/inboxes/${inboxId}/quarantine?page=${page}&page_size=${pageSize}`)
      );
      commit('SET_QUARANTINE', res.data);
    } catch (err) {
      commit('SET_ERROR', err);
      throw err;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async handleQuarantineAction({ dispatch }, { accountId, inboxId, messageId, action }) {
    try {
      await axios.post(
        knowledgeProxy(accountId, `/whitelist/accounts/${accountId}/inboxes/${inboxId}/quarantine/${messageId}/action`),
        { action }
      );
      dispatch('getQuarantine', { accountId, inboxId });
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  async getConfig({ commit }, { accountId, inboxId }) {
    commit('SET_LOADING', true);
    try {
      const res = await axios.get(
        knowledgeProxy(accountId, `/whitelist/accounts/${accountId}/inboxes/${inboxId}/config`)
      );
      commit('SET_CONFIG', res.data);
    } catch (err) {
      commit('SET_ERROR', err);
      throw err;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async testSimilarity(_, { accountId, inboxId, content }) {
    try {
      const res = await axios.post(
        knowledgeProxy(accountId, `/whitelist/accounts/${accountId}/inboxes/${inboxId}/similarity-check`),
        { content }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
